import { render, staticRenderFns } from "./fourPart.vue?vue&type=template&id=628eab7c&scoped=true&"
import script from "./fourPart.vue?vue&type=script&lang=js&"
export * from "./fourPart.vue?vue&type=script&lang=js&"
import style0 from "./fourPart.vue?vue&type=style&index=0&id=628eab7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628eab7c",
  null
  
)

export default component.exports